import React from 'react';

class NumberPicker extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.minus = this.minus.bind(this);
        this.plus = this.plus.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    minus(e) {
        e.stopPropagation();
        let newVal = parseInt(this.props.value);
        newVal--;
        if(newVal < 0) {
            newVal = 0;
        }

        this.onChange(newVal);
    }

    getValue() {
        let newVal = this.formatValue(this.props.value);

        if( !isNaN(parseFloat(this.props.value)) && isFinite(this.props.value)) {
            newVal = parseInt(this.props.value);
        }else{
            newVal = 0;
        }

        return newVal;
    }

    plus(e) {
        e.stopPropagation();
        let newVal = this.getValue();
        newVal++;
        this.onChange(newVal);
    }

    handleChange(e) {
        let val = e.target.value;
        this.onChange(val);
    }

    handleBlur(e) {
        let val = e.target.value;

        if(val < 0) {
            val = 0;
        }

        this.onChange(val);
    }

    formatValue(val) {
        if(this.props.max) {
            if(val > this.props.max) {
                val = this.props.max;
            }
        }

        if(this.props.min) {
            if(val < this.props.min) {
                val = this.props.min;
            }
        }

        return val;
    }

    onChange(val) {
        val = this.formatValue(val);

        this.props.handleChange(val);
    }

    render() {
        return (
            <div className="input-group">
                <span className="input-group-btn">
                    <button className="btn btn-outline btn-default" onClick={this.minus} type="button"><i className="wb-minus"></i></button>
                </span>
                <input type="text" className="form-control" onBlur={this.handleBlur} onChange={this.handleChange} value={this.getValue()} style={{textAlign:'center'}} />
                <span className="input-group-btn"><button onClick={this.plus} className="btn btn-outline btn-default" type="button"><i className="wb-plus"></i></button></span>
                {
                    this.props.type ?
                        <span className="input-group-addon">{this.props.type}</span>:null
                }
            </div>
        );
    }


}

export default NumberPicker;




// WEBPACK FOOTER //
// ./components/widgets/NumberPicker.js